// Toolkit functions.
import { combineReducers, configureStore } from '@reduxjs/toolkit';

// Api object representation import from auto-generated file api.ts.
import {
    DroitsJsonldDroitReadCollection as DroitsUtilisateurApiObject,
    GroupesJsonldGroupReadCollection as GroupsUtilisateurApiObject,
    JournauxJsonldJournauxReadCollection as JournauxUtilisateurApiObject,
    MarquesJsonldSocieteMarqueReadCollection as MarquesUtilisateurApiObject,
    PolesJsonldDefPoleReadCollection as PolesUtilisateurApiObject,
    ServicesJsonldServiceReadCollection as ServicesUtilisateurApiObject,
    DomaineJsonldUtilisateurReadDomaineRead as DomainesUtilisateurApiObject,
    JointureUtilisateurGroupeTravailJsonldUserworkgroupRead,
    GroupesDeTravailJsonldUtilisateurReadDomaineRead,
    UtilisateursJsonldUtilisateurRead,
    ConfigurationParameters as UtilisateursConfigurationParameters,
    AntennesJsonldAntenneRead,
    UtilisateursJsonldUserworkgroupRead,
} from '../../openApi/ApiUtilisateur';

// API Utilisateurs reducer constructor.
import { buildUtilisateurRedux } from './utilisateursReducer';
import { UTILISATEUR_REDUCER_NAME } from './constants';

// Type aliases export.
export type UtilisateurApiObject = UtilisateursJsonldUtilisateurRead & Record<string, unknown>;
export interface UtilisateursGroupesTravailWithGroupLib extends UtilisateursJsonldUserworkgroupRead {
    groupetravailLibelle: string | undefined;
}
export type AntennesUtilisateurApiObject = AntennesJsonldAntenneRead & Record<string, unknown>;
export type GroupeTravailUtilisateurApiObject = GroupesDeTravailJsonldUtilisateurReadDomaineRead &
    Record<string, unknown>;
export type UtilisateurGroupeTravailUtilisateurApiObject =
    JointureUtilisateurGroupeTravailJsonldUserworkgroupRead & Record<string, unknown>;
export {
    type DroitsUtilisateurApiObject,
    type GroupsUtilisateurApiObject,
    type JournauxUtilisateurApiObject,
    type MarquesUtilisateurApiObject,
    type PolesUtilisateurApiObject,
    type ServicesUtilisateurApiObject,
    type DomainesUtilisateurApiObject,
    type UtilisateursConfigurationParameters,
};

// Mutable type export.
export type Mutable<T> = {
    -readonly [key in keyof T]: T[key];
};

// Reducer creation.
const { reducer } = buildUtilisateurRedux({});

/**
 * Reducers combination into Api utilisateurs main reducer.
 * Useless here since there's only one reducer.
 */
const utilisateursReducer = combineReducers({
    [UTILISATEUR_REDUCER_NAME]: reducer,
});

/**
 * Create Api utilisateurs store.
 */
export const utilisateursStore = configureStore({
    reducer: utilisateursReducer,
    devTools: {
        name: 'Utilisateurs Store',
    },
});

// Type aliases export.
export type UtilisateursReducerType = typeof utilisateursReducer;
export type UtilisateursStateType = ReturnType<typeof utilisateursStore.getState>;
export type UtilisateursAppDispatch = typeof utilisateursStore.dispatch;
